import defer from 'lodash/defer';
import { observeStore, initObserveStore } from '@resy/ui-kitchen';
import getConnectedActions from '../../modules/actions/connectedActions';
import { selectIsConcierge, selectIsGlobalDiningAccess } from '../../../../ui-kitchen/src/reducers/userSlice';
import { shouldDisplayAd } from '../../../../ui-kitchen/src/components/AmexAds/helpers';

angular.module('resyApp')
  .component('resyAccount', {
    templateUrl: 'components/account/account.html',
    controller: ResyAccountController,
    controllerAs: 'vm',
    bindings: {
      active: '<',
    },
  });

function ResyAccountController(
  $document,
  $location,
  $ngRedux,
  $rootScope,
  $routeParams,
  $scope,
  $window
) {
  /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["$rootScope"] }] */
  const vm = this;
  const store = $rootScope.reduxStore;
  const { dispatch, getState } = store;

  vm.modalType = ($routeParams.modal && $routeParams.modal.toLowerCase());
  vm.isGda = $routeParams['gda-eligibility'] === 'true';
  vm.selectedDate = $rootScope?.searchProps?.searchFields?.datepicker?.model;
  vm.getQueuedData = getQueuedData;
  vm.setQueuedData = setQueuedData;
  vm.showAuthModal = showAuthModal;
  vm.store = $ngRedux;
  vm.flushRoute = () => defer(() => $rootScope.$apply());

  vm.items = [
    {
      name: 'Concierge Reservations',
      path: 'account/concierge-reservations',
      translationKey: 'concierge_reservations',
      selectedMatcher: 'concierge-reservations',
      isSelected: false,
      isConcierge: true,
    },
    {
      name: 'Reservations &amp; Notify',
      path: 'account/reservations-and-notify',
      translationKey: 'reservations_and_notify',
      selectedMatcher: 'reservations-and-notify',
      isSelected: false,
    },
    {
      name: 'Profile',
      path: 'account/profile',
      translationKey: 'profile',
      selectedMatcher: 'profile',
      isSelected: false,
    },
    {
      name: 'Lists',
      path: 'account/lists',
      translationKey: 'lists.title',
      selectedMatcher: 'lists',
      isSelected: false,
    },
    {
      name: 'Payment Methods',
      path: 'account/payment-methods',
      translationKey: 'payment_methods_title',
      selectedMatcher: 'payment-methods',
      isSelected: false,
    },
    {
      name: 'Communication',
      path: 'account/communication',
      translationKey: 'communication_title',
      selectedMatcher: 'communication',
      isSelected: false,
    },
    {
      name: 'Global Dining Access',
      onClick: presentOnboardingLite,
      translationKey: 'rga',
      isGlobalDiningAccess: true,
    },
    {
      name: 'Help & Feedback',
      path: 'account/help-and-feedback',
      translationKey: 'help_and_feedback_heading',
      selectedMatcher: 'help-and-feedback',
      isSelected: false,
    },
  ];

  vm.isScrolled = false;
  vm.presentCancelation = presentCancelation;

  let isWatchingScroll = false;

  vm.$onInit = onInit;
  vm.isConcierge = selectIsConcierge(getState());
  vm.isGlobalDiningAccess = selectIsGlobalDiningAccess(getState());
  vm.shouldShowAmexAds = selectShouldShowAmexAds(getState()) ?? false;
  vm.loadReservations = loadReservations;
  vm.venueReservationsList = [];

  const onFavoritesSliceChange = (favorite) => {
    vm.favoriteVenues = favorite;
    defer(() => $scope.$apply());
  };

  const unsubscribeFavorites = observeStore(
    store,
    ({ favorite }) => (favorite),
    onFavoritesSliceChange
  );

  const onVenueReservationsSliceChange = (venueReservationsSlice) => {
    if (venueReservationsSlice.status === 'success') {
      vm.venueReservationsList = venueReservationsSlice.data.reservations;
      defer(() => $scope.$apply());
    }
  };
  const observeVenueReservationsSlice = initObserveStore(store, ({ venueReservations }) => (venueReservations));
  const unsubscribeVenueReservations = observeVenueReservationsSlice(onVenueReservationsSliceChange);

  let prevUserData = null;
  const onUserSliceChange = (userSlice) => {
    const { userData } = userSlice;

    // Angular 'UserAuth' event handling
    if (prevUserData === null && userData) {
      vm.isGlobalDiningAccess = selectIsGlobalDiningAccess(getState());
      vm.isConcierge = selectIsConcierge(getState());
      assessActive(vm.active);
    }

    prevUserData = userData;
    defer(() => $scope.$apply());
  };

  const observeUserSlice = initObserveStore(store, ({ user }) => (user));
  const unsubscribeUserSlice = observeUserSlice(onUserSliceChange);

  const unsubscribeExperiments = observeStore(
    store,
    ({ experiments, ipdata }) => ({
      experiments,
      countryCode: ipdata?.countryCode,
    }),
    () => {
      vm.shouldShowAmexAds = selectShouldShowAmexAds(getState()) ?? false;
      defer(() => $scope.$apply());
    }
  );

  $scope.$on('$destroy', () => {
    unsubscribeFavorites();
    unsubscribeVenueReservations();
    unsubscribeUserSlice();
    unsubscribeExperiments();
  });

  function setQueuedData(payload) {
    if (payload) {
      Object.keys(payload).map((key) => {
        $location.search(key, payload[key]);
        return true;
      });
    }
  }

  function getQueuedData(keys) {
    let payload = null;
    keys.map((key) => {
      const search = $location.search();
      const val = search[key];
      if (val) {
        $location.search(key, null);
        payload = {
          ...payload,
          [key]: val,
        };
      }
      return true;
    });
    return payload;
  }

  function presentOnboardingLite() {
    $rootScope.$broadcast('MODAL', 'onboarding-lite');
  }

  function presentCancelation(reservation) {
    if (reservation.conciergeResyToken) {
      $location.search('conciergeToken', reservation.conciergeResyToken);
    }
    $location.search('cancelToken', reservation.token);
    $rootScope.$broadcast('MODAL', 'reservation-cancel');
  }

  function onInit() {
    assessActive(vm.active);
    watchScroll();
  }

  function showAuthModal() {
    $rootScope.$broadcast('MODAL', 'signin');
  }

  function assessActive(active) {
    vm.items.forEach((item) => {
      if (item.selectedMatcher === active) {
        item.isSelected = true; // eslint-disable-line
      }
    });
  }

  function watchScroll() {
    $document.ready(() => {
      if (!$rootScope.matchMedia.lg && !isWatchingScroll) {
        $window.addEventListener('scroll', onScroll);
        isWatchingScroll = true;
      }
    });
  }

  function onScroll() {
    if ($window.scrollY <= 0) {
      vm.isScrolled = false;
    } else {
      vm.isScrolled = true;
    }
    $rootScope.$apply();
  }

  function selectShouldShowAmexAds(state) {
    return shouldDisplayAd(
      state?.experiments,
      'account_page',
      state?.ipdata?.countryCode
    );
  }

  function loadReservations(venueId, selectedDate, selectedQuantity) {
    const { getVenueReservationsThunk } = getConnectedActions(dispatch);
    const params = {
      venue_id: venueId,
      day: moment(selectedDate).format('YYYY-MM-DD'),
      party_size: selectedQuantity,
      resy_token: $location.search().resyToken,
    };
    return getVenueReservationsThunk({ params });
  }
}

export default () => {};
